// Member account status — the ONE set of names every screen shows.
//
// The server decides the status (helpers/statsFilters.js in luxury-life-server, field
// `statusBucket` / `acct` / `account` on rows, per-status keys on totals). This file only
// names it. Before this existed each screen kept its own map, and the same member read
// "Active" on one screen and "Hidden by Admin" on the next.
//
// Model agreed 2026-09-17 (first match wins):
//   deleted > deactivated > suspended > approved > hidden > inactive > ghost
// "Active" is NOT a status: it is the total Approved + Hidden, i.e. every completed profile.
// Screens colour these with their own CSS variables; only names and meanings live here.

export const STATUS_ORDER = ['approved', 'hidden', 'inactive', 'ghost', 'deactivated', 'suspended', 'deleted'];

// The statuses that make up the derived Active total.
export const ACTIVE_STATUSES = ['approved', 'hidden'];

export const STATUS_LABEL = {
  active: 'Active',
  approved: 'Approved',
  hidden: 'Hidden',
  inactive: 'Inactive',
  ghost: 'Ghost',
  deactivated: 'Deactivated',
  suspended: 'Suspended',
  deleted: 'Deleted',
};

export const STATUS_DESCRIPTION = {
  active: 'Approved + Hidden — every member who completed their profile',
  approved: 'Profile complete, selfie approved and visible on search right now',
  hidden: 'Profile complete, but not on search — hidden by the AI Shortlist, an admin, a shadow hide, the member, or visibility off',
  inactive: 'Was complete, but the profile photo was removed or the profile dropped below 100%',
  ghost: 'Has not finished signup — profile never reached 100%, or the selfie is not approved (rejected, pending or not sent)',
  deactivated: 'The member turned their account off',
  suspended: 'Suspended by an admin',
  deleted: 'Account deleted',
};

// Label for any status key; an unknown key reads as itself rather than disappearing.
export const statusLabel = (key) => STATUS_LABEL[key] || (key ? String(key) : '—');

// Active total from a row of per-status counts. Keyed on `approved`, which only a v3
// server sends: a pre-v3 row has `hidden` too, but its `active` meant what Approved means
// now, so the total there is active + hidden.
export const activeTotal = (row = {}) => {
  if (row.approved != null) return (row.approved || 0) + (row.hidden || 0);
  return (row.active || 0) + (row.hidden || 0);
};
